import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlSendLoad extends Layout {
    checkboxSendLoadFuelOptimization: Checkbox;
    checkboxSendLoadMaptuitDirections: Checkbox;
    checkboxSendLoadPayrollInformation: Checkbox;
    checkboxSendLoadRoute: Checkbox;
    checkboxSendLoadShipperDirections: Checkbox;
    checkboxSendNextPreassignedLoad: Checkbox;
    checkboxSendNextPreplan: Checkbox;
    checkboxSendNoLoadMessage: Checkbox;
    panelSendLoadOne: Panel;
    panelSendLoadSection: Panel;
    panelSendLoadThree: Panel;
    panelSendLoadTwo: Panel;
    sourceMCExAppControl: DataSource;
    textboxDriverID: Textbox;
    textboxFormNumber: Textbox;
    textboxLocationCode: Textbox;
    textboxPayeePIN: Textbox;
    textboxPayrollDate: Textbox;
    textboxSSN: Textbox;
    textboxStopNumber: Textbox;
}
